<div class="back-button" [routerLink]="'/' + pageName" [ngClass]="{'standalone':standalone}">
    <i class="fas fa-chevron-left"></i>
</div>